import React from 'react';
import PropTypes from 'prop-types';

import { TextChild } from './styles';

const Text = ({
  textBackgroundColor,
  textColor,
  textContent,
  textSize,
  titleBackgroundColor,
  titleColor,
  titleContent,
  titleSize
}) => (
  <>
    <TextChild
      dangerouslySetInnerHTML={{ __html: titleContent }}
      textBackcolor={titleBackgroundColor}
      textColor={titleColor}
      textSize={titleSize}
    />
    <TextChild
      dangerouslySetInnerHTML={{ __html: textContent }}
      textBackcolor={textBackgroundColor}
      textColor={textColor}
      textSize={textSize}
    />
  </>
);

Text.defaultProps = {
  textBackgroundColor: 'gray',
  textColor: 'black',
  textContent: 'This is your custom text.',
  textSize: '14px',
  titleBackgroundColor: 'gray',
  titleColor: 'black',
  titleContent: 'This is your custom title',
  titleSize: '18px'
};

Text.propTypes = {
  textBackgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  textContent: PropTypes.string,
  textSize: PropTypes.string,
  titleBackgroundColor: PropTypes.string,
  titleColor: PropTypes.string,
  titleContent: PropTypes.string,
  titleSize: PropTypes.string
};

export default Text;
